import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import EventLayout from './components/EventLayout'; // new
import EventLayout2 from './components/event2/EventLayout2'; // new
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Speakers from "./components/Speakers";
import Speakers2 from "./components/event2/Speakers2";
import Events from "./components/Events";
import Connect from "./components/Connect";
import Footer from "./components/Footer";
import Schedule from "./components/Schedule";
import Schedule2 from "./components/event2/Schedule2";
import Location from "./components/Location";
import Location2 from "./components/event2/Location2";
import Theme from "./components/Theme";
import Theme2 from "./components/event2/Theme2";
import Team from "./components/Team";
import Team2 from "./components/event2/Team2";
import Highlights from "./components/Highlights";
import Sponsors from "./components/Sponsors";

console.table({
  Navbar: typeof Navbar,
  Hero: typeof Hero,
  About: typeof About,
  Events: typeof Events,
  Connect: typeof Connect,
  Footer: typeof Footer,

  EventLayout: typeof EventLayout,
  EventLayout2: typeof EventLayout2,

  Theme: typeof Theme,
  Theme2: typeof Theme2,

  Speakers: typeof Speakers,
  Speakers2: typeof Speakers2,

  Highlights: typeof Highlights,
  Sponsors: typeof Sponsors,

  Team: typeof Team,
  Team2: typeof Team2,

  Schedule2: typeof Schedule2,
  Location2: typeof Location2,
});

function ScrollToAnchor() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // Delay helps with layout settling on slow devices
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [hash]);

  return null;
}

// Wrap homepage content in a separate component
function HomePage() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Events />
      <Connect />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToAnchor /> {/* 👈 Add this line */}
      <Routes>
        {/* Homepage */}
        <Route path="/" element={<HomePage />} />

        {/* TEDxSetapak 2025 - Existing Event */}
        <Route path="/event" element={<EventLayout />}>
          <Route path="theme" element={<Theme />} />
          <Route path="speakers" element={<Speakers />} />
          <Route path="highlights" element={<Highlights />} />
          <Route path="sponsors" element={<Sponsors />} />
          <Route path="team" element={<Team />} />
        </Route>

        {/* TEDxSetapak 2026 - Event 2 */}
        <Route path="/event2" element={<EventLayout2 />}>
          <Route path="theme" element={<Theme2 />} />
          <Route path="speakers" element={<Speakers2 />} />
          <Route path="schedule" element={<Schedule2 />} />
          <Route path="team" element={<Team2 />} />
          <Route path="location" element={<Location2 />} />
        </Route>

        {/* 404 */}
        <Route
          path="*"
          element={<div style={{ color: "white" }}>404 - Not Found</div>}
        />
      </Routes>
    </Router>
  );
}

export default App;
